import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type LOCALE } from '../../i18n'

import { recommendationAccessorGetUnderscoreLocale } from './recommendationAccessorGetUnderscoreLocale'

export const recommendationAccessorGetLocalizedProductImageAltText = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productImageAltText =
    product[
      `image_alt_text_${recommendationAccessorGetUnderscoreLocale(locale)}`
    ]

  if (!productImageAltText) {
    return ''
  }

  return productImageAltText
}
